import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./locales";
import LanguageDetector from "i18next-browser-languagedetector";
const i18n = createInstance({
    fallbackLng: "en",
    debug: false,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: translations,
    ns: ["entities", "common", "components"],
    defaultNS: "common",
});
i18n.use(initReactI18next).use(LanguageDetector).init();
export default i18n;
